<template>
  <div class="loading">
    <i class="fas fa-spinner fa-5x fa-spin"></i>
    <div>Authenticating...</div>
  </div>
</template>

<script>

  import { UserManager } from 'oidc-client-ts'
  import store from "@/store";

  export default {
    data() {
      return {}
    },
    created() {

      const oidcSettings = {
        authority: process.env.VUE_APP_AUTHORITY,
        client_id: "10333f08-7e8f-4cc4-bba0-e66f4e5505d0",
        redirect_uri: location.origin + '/oidc',
        response_type: 'code',
        scope: "openid", // "openid profile email eduperson_entitlement",
        loadUserInfo: true,
      }
      const userManager = new UserManager(oidcSettings)

      const query = this.$route.query


      if(!query.state)
        userManager.signinRedirect()
      else {
        userManager.signinCallback().then((user) => {
          if (user){
            localStorage.setItem("session", JSON.stringify(user))
            store.state.isLogged = true
            window.location.href = location.origin + "/select-option"
          }
        }).catch(function(err) { console.error(err) });
      }
    }

  }
</script>

<style scoped>
  .loading{
    text-align: center;
    padding: max(1em, calc(20vh - 40px)) 0;

    div {
      font-size: 1.5em;
      padding-top: 1em;
    }
  }
</style>
